import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { ResponsiveScrollView, ResponsiveView } from 'APP/Converse/Layout'
import Header from 'APP/Converse/Header'
import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'
import LogoHeader from 'APP/Components/LogoHeader'
import { Images } from 'APP/Themes'

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const ContentFooterContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

export interface ButtonConfig {
  title: string
  analyticsName: string
  onPress: () => void
}

export interface HintCtaConfig {
  text: string
  onPress: () => void
}

export interface AccountLinkingLayoutProps {
  title: string
  subtitle: string | React.ReactElement | null
  primaryButtonConfig?: ButtonConfig
  secondaryButtonConfig?: ButtonConfig
  tertiaryButtonConfig?: ButtonConfig
  onBackButtonPress?: () => void
  hintText?: string | null
  hintCtaConfig?: HintCtaConfig
}

const AccountLinkingLayout: React.FC<AccountLinkingLayoutProps> = ({
  title,
  subtitle,
  primaryButtonConfig,
  secondaryButtonConfig,
  tertiaryButtonConfig,
  onBackButtonPress,
  hintText,
  hintCtaConfig,
}) => {
  return (
    <ScreenContainer>
      <ResponsiveScrollView alwaysBounceVertical={false} keyboardShouldPersistTaps="always">
        <Header hideBackButton={!onBackButtonPress} onBackButtonPress={onBackButtonPress} />

        <ContentContainer>
          <LogoHeader source={Images.logoBlue} title={title} subtitle={subtitle} />

          <ButtonContainer>
            {primaryButtonConfig && (
              <Button
                variant="primary"
                widthVariant="full"
                title={primaryButtonConfig.title}
                analyticsName={primaryButtonConfig.analyticsName}
                onPress={primaryButtonConfig.onPress}
                testID="WELCOME_CTA_PRIMARY_BTN"
              />
            )}
            {secondaryButtonConfig && (
              <Button
                variant="secondary"
                widthVariant="full"
                title={secondaryButtonConfig.title}
                analyticsName={secondaryButtonConfig.analyticsName}
                onPress={secondaryButtonConfig.onPress}
                testID="WELCOME_CTA_SECONDARY_BTN"
              />
            )}
            {tertiaryButtonConfig && (
              <Button
                variant="tertiary"
                widthVariant="full"
                title={tertiaryButtonConfig.title}
                analyticsName={tertiaryButtonConfig.analyticsName}
                onPress={tertiaryButtonConfig.onPress}
                testID="WELCOME_CTA_TERTIARY_BTN"
              />
            )}
          </ButtonContainer>

          {(hintText || hintCtaConfig) && (
            <ContentFooterContainer>
              {hintText && <Typography variant="bodySmall">{hintText}</Typography>}
              {hintCtaConfig?.text && (
                <Typography
                  variant="link"
                  onPress={hintCtaConfig.onPress}
                  testID="WELCOME_CTA_HINT"
                >
                  {hintCtaConfig.text}
                </Typography>
              )}
            </ContentFooterContainer>
          )}
        </ContentContainer>
      </ResponsiveScrollView>
    </ScreenContainer>
  )
}

export default AccountLinkingLayout
